export default __webpack_public_path__ + "db249307fbc7f460379ba5802e19ac18.png";